import React, { useEffect, useState } from 'react';
import classes from "./style.module.scss";
import { Icons, Images } from '../../assets';

const Redirect = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    os: '',
    browser: '',
  });

  const googleStoreURL = 'https://play.google.com/store/apps/details?id=com.kg.repair_rewards'
  const iOSStoreURL = 'https://apps.apple.com/in/app/kg-repair-rewards/id6736611560'

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const platform = navigator.platform;

    const os = (() => {
      if (/android/i.test(userAgent)) {
        return 'Android';
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
      }
      if (/Windows NT/i.test(userAgent)) {
        return 'Windows';
      }
      if (/Macintosh|Mac OS X/i.test(userAgent)) {
        return 'macOS';
      }
      if (/Linux/i.test(userAgent)) {
        return 'Linux';
      }
      return 'Unknown';
    })();

    const browser = (() => {
      if (/chrome|chromium|crios/i.test(userAgent)) {
        return 'Chrome';
      }
      if (/firefox|fxios/i.test(userAgent)) {
        return 'Firefox';
      }
      if (/safari/i.test(userAgent) && !/chrome/i.test(userAgent)) {
        return 'Safari';
      }
      if (/msie|trident/i.test(userAgent)) {
        return 'Internet Explorer';
      }
      if (/edge/i.test(userAgent)) {
        return 'Edge';
      }
      if (/opera|opr/i.test(userAgent)) {
        return 'Opera';
      }
      return 'Unknown';
    })();

    setDeviceInfo({ os, browser });
  }, []);

  useEffect(() => {
    if (deviceInfo?.os !== '') {
      let osInfo = deviceInfo?.os
      if (osInfo == 'Windows' || osInfo == 'Android' || osInfo == 'Linux') {
        window.open(googleStoreURL, "_self")
      } else if (osInfo == 'iOS' || osInfo == 'macOS')
        window.open(iOSStoreURL, "_self")
    }
  }, [deviceInfo])

  const handleRedirectTo = (url) => {
    window.open(url, '_blank')
  };

  return (
    <div className='flex items-center justify-center w-[100%] h-[100%]'>
      <div className={`${classes.redirectPage}`}>
        <div className={classes.logoContainer}>
          <img src={Icons.kgLogo} className={classes.appLogo} />
        </div>
        <p>You are in {deviceInfo?.browser}/{deviceInfo?.os}</p>
        <img src={Images.googleStore} className={classes.appStoreLogo} onClick={() => handleRedirectTo(googleStoreURL)} />
        <img src={Images.appleStore} className={classes.appStoreLogo} onClick={() => handleRedirectTo(iOSStoreURL)} />
      </div>
    </div>
  );
}

export default Redirect;
